// Generated from the approved MagicPath revision 440407833612296192. Do not hand-edit; update the source worktree instead.
import { useState } from 'react';
const currentPlate = "/assets/page05-origin.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
const disciplines = [{
  id: 'sports',
  label: <>SPORTS<br />PSYCHOLOGY</>
}, {
  id: 'mindfulness',
  label: <>MINDFULNESS</>
}, {
  id: 'buddhism',
  label: <>BUDDHISM</>
}, {
  id: 'habit',
  label: <>HABIT<br />SCIENCE</>
}, {
  id: 'performance',
  label: <>PERFORMANCE<br />TRAINING</>
}, {
  id: 'attention',
  label: <>ATTENTION<br />CONTROL</>
}, {
  id: 'gambling',
  label: <>GAMBLING<br />BEHAVIOR</>
}];
export const Page05WhereItComesFrom = () => {
  const [activeNav, setActiveNav] = useState('ASSESSMENT');
  const [activeDiscipline, setActiveDiscipline] = useState<string | null>(null);
  return <main className="origin-page">
      <img className="origin-photo" src={currentPlate} alt="Seven underwater currents converging beneath a shaft of light" />
      <div className="origin-grade" aria-hidden="true" />

      <button className="origin-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
      <nav className="origin-navigation" aria-label="Primary navigation">
        {navigation.map(item => <button type="button" key={item} className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>
            {item}
          </button>)}
      </nav>

      <section className="origin-center" aria-labelledby="origin-heading">
        <h1 id="origin-heading">NOBODY HAS PUT THESE<br />IN THE SAME ROOM BEFORE.</h1>
        <span className="origin-center-rule" aria-hidden="true" />
        <h2 className={activeDiscipline ? 'edge active' : 'edge'}>THE EDGE</h2>
      </section>

      <div className="origin-disciplines" aria-label="Disciplines that form the edge">
        {disciplines.map(item => <button type="button" key={item.id} className={`discipline discipline-${item.id}${activeDiscipline === item.id ? ' active' : ''}`} onMouseEnter={() => setActiveDiscipline(item.id)} onMouseLeave={() => setActiveDiscipline(null)} onFocus={() => setActiveDiscipline(item.id)} onBlur={() => setActiveDiscipline(null)} aria-pressed={activeDiscipline === item.id}>
          
            <span>{item.label}</span><i aria-hidden="true" />
          </button>)}
      </div>

      <footer className="origin-footer">
        <div className="origin-timecode"><strong>05</strong><span>/ 11</span><p>WHERE IT COMES FROM</p></div>
        <div className="origin-progress" aria-label="Scene 5 of 11"><span /><i /></div>
      </footer>
    </main>;
};